export const DEFAULT_MAC_DOWNLOAD_URL = "https://github.com/sodhera/orecce-releases/releases/latest/download/Orecce-mac.dmg";
export const FREE_TEST_MAC_DOWNLOAD_URL = "https://github.com/sodhera/orecce-releases/releases/download/v0.1.2/Orecce-mac.dmg";

/** The public site distributes only the native macOS application. */
export function macDownloadUrl(configured: string | undefined): string {
  return configured?.trim() || DEFAULT_MAC_DOWNLOAD_URL;
}
